import { useMemo } from "react";
import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import { useBoardViews } from "../../contexts/views/viewsContext";
import ViewTitle from "../../layout/components/ViewTitle";
import Enums from "../../types/enums";

export const MyCompletedTasks = () => {
  const { systemViews } = useBoardViews();

  const atmView = useMemo(
    () =>
      systemViews.find((v) => v.ViewType === Enums.ViewType.MyCompletedTasks),
    [systemViews]
  );

  return (
    <>
      <div className="row">
        <ViewTitle viewId={atmView?.Id} viewName={atmView.Name} />
      </div>
      <div className="row">
        <TaskGrid viewId={atmView?.Id} />
      </div>
    </>
  );
};
